import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TypedMemo } from '../../common/types';
import { SerializedScheduledPost } from '../promote/types';
import { platformMeta, platformSolidFill } from '../promote/platformMeta';
import { relativeSlotLabel } from '../promote/relativeSlotLabel';
import { PostStatusPill } from '../promote/calendar/PostStatusPill';
import { artistHomeMessages as messages } from './artistHomeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Home; each part uses its own slice of it */
import styles from './ArtistHome.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PromoteNextPostsProps {
  posts: SerializedScheduledPost[];
}

/** "Next scheduled" and the next three posts (design a1). */
const PromoteNextPostsComponent: React.FC<PromoteNextPostsProps> = ({ posts }) => {
  const intl = useIntl();

  return (
    <div className={styles.promoColumn}>
      <div className={styles.sectionKey}>{intl.formatMessage(messages.promoteNextScheduled)}</div>
      {posts.length === 0 && (
        <small className="text-muted">{intl.formatMessage(messages.promoteNothingScheduled)}</small>
      )}
      {posts.map((post) => {
        const meta = platformMeta[post.platform];
        return (
          <div key={post.uuid} className={styles.post}>
            <span className={styles.postWhen}>{relativeSlotLabel(intl, post.scheduledAt)}</span>
            <span
              className={styles.channelMark}
              style={{ background: platformSolidFill(post.platform) }}
              title={meta.name}
            >
              <FontAwesomeIcon icon={meta.icon} />
            </span>
            <span className={styles.postText}>{post.caption}</span>
            <PostStatusPill status={post.status} scheduledAt={post.scheduledAt} />
          </div>
        );
      })}
    </div>
  );
};

export const PromoteNextPosts = TypedMemo(PromoteNextPostsComponent);
